import { useEffect, useRef, useState } from "react";
import { PaperPlaneRight, Flag } from "@phosphor-icons/react";
import { toast } from "sonner";
import { teleproApi } from "../../lib/teleproApi";

// VAGUE 46 — échange avec le faux prospect joué par l'IA.
export default function RoleplayChat({ session, onUpdate }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" }); }, [session.messages.length, busy]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim() || busy) return;
    setBusy(true);
    try {
      const r = await teleproApi.post(`/training/sessions/${session.id}/reply`, { message: text.trim() });
      onUpdate(r.data);
      setText("");
    } catch {
      toast.error("Réponse non envoyée, réessaie");
    } finally {
      setBusy(false);
    }
  };

  const evaluate = async () => {
    setBusy(true);
    try {
      const r = await teleproApi.post(`/training/sessions/${session.id}/evaluate`);
      onUpdate(r.data);
    } catch {
      toast.error("Évaluation indisponible, réessaie");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="roleplay-chat">
      {session.source === "standard" && (
        <p className="text-[11px] text-muted-foreground bg-muted/50 border border-border rounded-sm px-2 py-1.5" data-testid="roleplay-standard-note">
          L&apos;IA n&apos;est pas disponible : le prospect suit un scénario standard.
        </p>
      )}
      <div className="space-y-2 max-h-[45vh] overflow-y-auto pr-1">
        {session.messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "telepro" ? "justify-end" : "justify-start"}`} data-testid={`roleplay-msg-${i}`}>
            <div className={`max-w-[85%] rounded-sm px-3 py-2 text-sm ${m.role === "telepro" ? "bg-primary text-primary-foreground" : "bg-muted border border-border"}`}>
              <div className="text-[9px] uppercase tracking-widest font-bold opacity-70 mb-0.5">{m.role === "telepro" ? "Toi" : "Prospect"}</div>
              {m.content}
            </div>
          </div>
        ))}
        {busy && <div className="text-xs text-muted-foreground animate-pulse" data-testid="roleplay-typing">Le prospect réfléchit…</div>}
        <div ref={endRef}/>
      </div>
      <div className="text-[11px] text-muted-foreground" data-testid="roleplay-turns">
        Réplique {session.turns}/{session.max_turns}{session.ended ? " · appel terminé" : ""}
      </div>
      {!session.ended && (
        <form onSubmit={send} className="flex gap-2">
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={1000}
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) send(e); }}
            placeholder="Ta réponse au prospect…" className="flex-1 border border-border rounded-sm px-2 py-1.5 text-sm bg-background resize-none focus:outline-none focus:border-primary"
            data-testid="roleplay-input"/>
          <button type="submit" disabled={busy || !text.trim()} className="px-3 bg-primary text-primary-foreground rounded-sm disabled:opacity-50" aria-label="Envoyer" data-testid="roleplay-send">
            <PaperPlaneRight size={16} weight="fill"/>
          </button>
        </form>
      )}
      <button type="button" onClick={evaluate} disabled={busy || session.turns === 0}
        className={`w-full rounded-sm py-2 text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-50 ${session.ended ? "bg-primary text-primary-foreground" : "border border-border hover:border-primary"}`}
        data-testid="roleplay-evaluate">
        <Flag size={14}/> Terminer l&apos;appel et être évalué
      </button>
    </div>
  );
}
